import {CanActivateFn} from '@angular/router';
import {inject} from '@angular/core';

import {LocalizedRouter} from "@app/presentation/services/localized-router";

export const hasDeeplinkGuard: CanActivateFn = (route, state) => {
  const localizedRouter = inject(LocalizedRouter);
  const deepLinkPath = route.queryParamMap.get('deepLink');
  if (deepLinkPath == null) {
    return true;
  }
  return localizedRouter.createUrlTree([deepLinkPath]);
};
